import { render, staticRenderFns } from "./WaitingListConfigurationTemplates.vue?vue&type=template&id=287f8d6b&"
import script from "./WaitingListConfigurationTemplates.vue?vue&type=script&lang=js&"
export * from "./WaitingListConfigurationTemplates.vue?vue&type=script&lang=js&"
import style0 from "./WaitingListConfigurationTemplates.vue?vue&type=style&index=0&id=287f8d6b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports